import Vue from "vue";
window.events = new Vue;

/*
 * T33a (walk 2026-09-18, T33, Log #370). THE FLASH.
 *
 * `window.flash`'s key and its JSON shape do NOT change: `flashMessage` with
 * `{message, level, action_name}`. 51 writers in 35 files depend on it, and two blades outside
 * the Vue build write it directly -- `auth/switch-entity-module.blade.php:83` and `:88`,
 * `auth/switch-object-entity-module.blade.php:80` and `:89`. Those four are exactly the case the
 * flash failed on, because neither blade mounts the top bar.
 *
 * WHAT MOVED IS THE DELIVERY POINT, not the channel. `checkForFlashableMessages` is no longer
 * called from this mixin's own `created()` and therefore no longer waits on `nav-bar` being
 * mounted: `global.mixin.js` mixes this file in and calls it from the `created()` that
 * `Vue.mixin(Globals)` (`app.js:103`) gives every component. This file keeps `window.flash` and
 * the method, so a component that still imports it is unchanged and unharmed.
 */
/*
 * THE RE-ENTRY GUARD (fix round 1, defect 1). `presentToast` calls `$bvToast.toast()`, which
 * SYNCHRONOUSLY constructs BootstrapVue's own `BVToastPop` component -- and `Vue.mixin(Globals)`
 * (`app.js:103`) gives that component the very `created()` that called us. So a toast raised while
 * `flashMessage` is still in `localStorage` reads the key again, raises another toast, and so on:
 * measured at 523 toasts on screen from one `window.flash(...)`. Two things stop it, and both are
 * kept because they answer different halves of it:
 *   1. the key is removed BEFORE the toast is presented, so the toast's own component finds nothing;
 *   2. this module-level flag, so that even a flash WRITTEN during the toast's construction cannot
 *      re-enter the delivery that is already in flight.
 * Neither moves the order the task fixes: `afterSavingDisposition()` still fires before the toast.
 */
let ftdFlashInFlight = false;

window.flash = function (message, level='success', action_name='') {
    let flashMessage = {
        message:message,
        level: level,
        action_name: action_name
    };
    localStorage.setItem('flashMessage', JSON.stringify(flashMessage));
}
export default {
    methods: {
        /**
         * @param deliver_regardless  the root's `mounted()` passes true: by then every component
         *                            that could claim an `added_disposition` event has been
         *                            created, so anything still held is delivered and the key is
         *                            cleared. A flash never outlives the page meant to show it.
         */
        checkForFlashableMessages(deliver_regardless = false){
            // a delivery is already in flight: the component asking is one the toast itself
            // created (see the guard's note at the head of this file)
            if (ftdFlashInFlight){
                return;
            }

            let flashMessageItem = localStorage.getItem('flashMessage');
            if (flashMessageItem){
                try {
                    flashMessageItem = JSON.parse(flashMessageItem);
                } catch (e) {
                    localStorage.removeItem('flashMessage');
                    return;
                }

                // THE EVENT BRANCH. `added_disposition` is not a message, it is an event, and it
                // must fire on the host that has `afterSavingDisposition()` (`assets/New.vue`).
                // Now that every component looks, a component that is not the host leaves the key
                // where it is instead of consuming it.
                const is_disposition_event = flashMessageItem.action_name === 'added_disposition';
                const is_disposition_host = this.hasOwnProperty('afterSavingDisposition');

                if (is_disposition_event){
                    if (is_disposition_host){
                        // the order is today's and is kept: the event fires BEFORE the toast and
                        // before the key is removed
                        this.afterSavingDisposition();
                    } else if (!deliver_regardless){
                        return;
                    }
                }

                // ONE TITLE GRAMMAR AND ONE DELAY (Log #370), replacing
                // "Success" / "Info" / "Error" at 1500 / 3000 / 3000. The title is decided in
                // `presentToast` from the variant; the words are repeated here only so this file
                // says which grammar it is on.
                let title, variant;
                const delay = 4000;
                if (flashMessageItem.level === 'success'){
                    title = 'Saved';
                    variant = 'success';
                } else if (flashMessageItem.level === 'info'){
                    title = 'Working';
                    variant = 'info';
                } else if (flashMessageItem.level === 'danger'){
                    title = 'Not saved';
                    variant = 'danger';
                }else{
                    title = 'Saved';
                    variant = 'success';
                }

                // THE KEY GOES FIRST, and only then is the toast raised. `presentToast` builds a
                // component that runs this same method, so a key still in `localStorage` at that
                // moment is a second toast, and a third, and a fourth (defect 1). The order the
                // task names is untouched: the `added_disposition` event above still fires before
                // the toast.
                localStorage.removeItem('flashMessage');

                // the message's own words are the writer's and are untouched
                ftdFlashInFlight = true;
                try {
                    this.presentToast(title,
                        flashMessageItem.message,
                        variant,
                        delay,
                        true,
                        true);
                } finally {
                    ftdFlashInFlight = false;
                }
            }

        }
    }
}
